var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInfoIconSmall = function SvgInfoIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    clipPath: "url(#infoIconSmall_svg__clip0_6700_589403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 .77c4.411 0 8 3.588 8 8 0 4.41-3.589 8-8 8s-8-3.59-8-8c0-4.412 3.589-8 8-8zm0 14.666a6.674 6.674 0 006.667-6.666A6.674 6.674 0 008 2.103 6.674 6.674 0 001.333 8.77 6.674 6.674 0 008 15.436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.333 7.436h1.334v5.334H7.333V7.436zM7.333 4.77h1.334v1.333H7.333V4.77z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infoIconSmall_svg__clip0_6700_589403"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 16 .77)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgInfoIconSmall;